import { inject } from "mobx-react";
import type { Store } from "../../../../../../client/stores";
import { VolumeInCircleIcon } from "../../../../../core/components/icons/VolumeInCircleIcon.component";
import { Remote } from "../../../../../core/components/remote/Remote.component";
import { isPWSSessionBackend } from "../../../../../core/lib/auth/backends/pws";
import { coastMediaService } from "../../../../../core/services/PWS";
import { PwsViewMediaEpisodeResponse } from "../../../../../core/services/PWS.types";
import { ButtonKind, FauxButton } from "../../../../../core/ui";
import { COAST_SHOW_TYPE } from "../../../lib/coastContent";

interface CoastShowAudioboxABVProps {
    episodesInfo: Record<string, PwsViewMediaEpisodeResponse>;
    episodes: string[];
    showUrl: "art-bell-vault" | "somewhere-in-time";
}

interface CoastShowAudioboxABVLoaderProps {
    episodes: string[];
    store?: Store;
    showType: string;
}

const CoastShowAudioboxABV = ({ episodes, episodesInfo, showUrl }: CoastShowAudioboxABVProps) => (
    <section className="audiobox-section coast-abv">
        <div className="audiobox-section-value">
            {Object.values(episodes).map((slug, i) =>
                showUrl && slug ? (
                    <div key={slug} className="link-with-icon">
                        <FauxButton
                            to={`/videos/${showUrl}/${slug}/`}
                            kind={ButtonKind.CUSTOMIZED}
                            className="media-link"
                            download="download"
                        >
                            <VolumeInCircleIcon fill="#fff" />
                        </FauxButton>

                        <FauxButton
                            to={`/videos/${showUrl}/${slug}/`}
                            kind={ButtonKind.CUSTOMIZED}
                            className="media-link"
                            download="download"
                        >
                            {episodesInfo[slug]?.video.title || `Episode ${i + 1}`}
                        </FauxButton>
                    </div>
                ) : null,
            )}
        </div>
    </section>
);

export const CoastShowAudioboxABVLoader = inject("store")(
    ({ store, episodes, showType }: CoastShowAudioboxABVLoaderProps) => {
        const session = store?.session.currentSession;

        if (!store || !episodes.length || !isPWSSessionBackend(session)) {
            return null;
        }
        const showUrl = showType === COAST_SHOW_TYPE.ART_BELL_VAULT ? "art-bell-vault" : "somewhere-in-time";

        return (
            <Remote
                loader={() => coastMediaService.getMediaEpisodeBySlugBulk(episodes, session.state.accessToken)}
                cacheKey={`coast-show-audiobox-abv-${episodes.join(",")}-${session.state.hasActiveSubscription}`}
                showLoading={true}
            >
                {({ data }) =>
                    data ? <CoastShowAudioboxABV episodes={episodes} episodesInfo={data} showUrl={showUrl} /> : null
                }
            </Remote>
        );
    },
);
